import { Text, View, Image, StyleSheet, TouchableOpacity, TextInput, Dimensions } from "react-native";
import React, { useState } from "react";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useStateContext } from "../lib/context";
import Toast from "react-native-toast-message";

const { width } = Dimensions.get("window");
// Calculate card width for 2 columns with some spacing
// Screen width - padding (20) - gap (10) / 2
const cardWidth = width < 768 ? (width - 40) / 2 : 200;

const Product = (props) => {
  const [count, setCount] = useState(1);
  const { onAdd, promoEro, promoDrn, isViajante } = useStateContext();
  
  const showToast = (product, cantidad) => {
    Toast.show({
      type: "success",
      text1: "AÑADIDO " + product,
      text2: "Cantidad: " + cantidad,
    });
  };

  const promoIdDrn = promoDrn;
  const promoIdEro = promoEro;

  const promoMatrix = [
    { not: "not" },
    { uno: 30, tres:  0, nueve: 0, dos: 10 },
    { uno: 30, tres: 30, nueve: 0, dos:  0 },
    { uno: 30, tres: 33, nueve: 0, dos: 10 },
    { uno: 25, tres: 25, nueve: 0, dos:  0 },
    { uno: 30, tres: 33, nueve: 0, dos: 10 },
    { uno: 32, tres: 36, nueve: 0, dos:  0 },
    { uno: 32, tres: 34, nueve: 0, dos: 10 },
    { uno: 34, tres: 38, nueve: 0, dos: 20 },
    { uno: 32, tres: 33, nueve: 0, dos: 10 },
    { uno: 34, tres: 34, nueve: 0, dos:  0 },
    { uno: 20, tres: 20, nueve: 0, dos:  0 },
    { uno: 32, tres: 34, nueve: 0, dos:  0 },
    { uno: 32, tres: 30, nueve: 0, dos: 10 },
    { uno: 28, tres: 28, nueve: 0, dos: 10 },
    { uno: 32, tres: 34, nueve: 0, dos:  0 },
    { uno: 30, tres: 33, nueve: 0, dos: 15 },
    { uno: 28, tres: 28, nueve: 0, dos: 10 },
    { uno: 32, tres: 30, nueve: 0, dos:  0 },
    { uno: 40, tres: 30, nueve: 0, dos: 10 },
  ];

  const chu =
    props.type == "1"
      ? promoMatrix[promoIdEro]?.uno || 0
      : props.type == "2"
      ? promoMatrix[promoIdDrn]?.dos || 0
      : props.type == "3"
      ? promoMatrix[promoIdEro]?.tres || 0
      : promoMatrix[promoIdEro]?.nueve || 0;

  const originalPrice = props.price * 1;
  const finalPrice = props.price - (parseFloat(chu) * props.price) / 100;

  return (
    <View style={[localStyles.card, { width: cardWidth }]}>
      {/* Discount Badge */}
      {chu > 0 && (
        <View style={localStyles.discountBadge}>
          <Text style={localStyles.discountText}>-{chu}%</Text>
        </View>
      )}

      {/* Image */}
      <View style={localStyles.imageContainer}>
        <Image
          style={localStyles.image}
          source={
            props.Image
              ? { uri: props.Image }
              : require("../assets/placeholder.png")
          }
          resizeMode="contain"
        />
      </View>

      {/* Info */}
      <View style={localStyles.infoContainer}>
        <Text style={localStyles.title} numberOfLines={2}>{props.name}</Text>
        <Text style={localStyles.sku}>{props.sku}</Text>
        
        {isViajante ? (
          <Text style={
            props.stock < 1 ? localStyles.outOfStock
            : props.stock < 3 ? localStyles.lowStock
            : localStyles.inStock
          }>
            Stock: {props.stock}
          </Text>
        ) : props.stock < 1 ? (
          <Text style={localStyles.outOfStock}>Sin Stock</Text>
        ) : props.stock < 3 ? (
          <Text style={localStyles.lowStock}>Poco Stock</Text>
        ) : (
          <Text style={localStyles.inStock}>Existencia</Text>
        )}

        <View style={localStyles.priceRow}>
          {chu > 0 && (
            <Text style={localStyles.oldPrice}>${originalPrice.toFixed(2)}</Text>
          )}
          <Text style={localStyles.price}>${finalPrice.toFixed(2)}</Text>
        </View>
      </View>

      {/* Actions */}
      <View style={localStyles.actionsContainer}>
        <View style={localStyles.quantityControl}>
          <TouchableOpacity 
            onPress={() => setCount((prev) => (prev > 1 ? prev - 1 : 1))}
            style={localStyles.qtyButton}
          >
            <Ionicons name="remove" size={16} color="#2a2a8e" />
          </TouchableOpacity>
          
          <TextInput
             style={localStyles.qtyInput}
             keyboardType="numeric"
             value={String(count)}
             onChangeText={(text) => {
               const val = parseInt(text);
               if (!isNaN(val) && val > 0) setCount(val);
               else if (text === "") setCount("");
             }}
          />
          
          <TouchableOpacity 
            onPress={() => setCount((prev) => prev + 1)}
            style={localStyles.qtyButton}
          >
            <Ionicons name="add" size={16} color="#2a2a8e" />
          </TouchableOpacity>
        </View>

        <TouchableOpacity
          style={localStyles.addButton}
          onPress={() => {
            showToast(props.name, count);
            onAdd(props, count);
          }}
        >
          <Text style={localStyles.addButtonText}>Agregar</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default Product;

const localStyles = StyleSheet.create({
  card: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 10,
    marginBottom: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: "center",
    maxWidth: 220, // Limit width on large screens
    flexGrow: 1,
  },
  imageContainer: {
    width: "100%",
    height: 120,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 8,
    backgroundColor: "#f9f9f9",
    borderRadius: 8,
  },
  image: {
    width: "90%",
    height: "90%",
  },
  discountBadge: {
    position: "absolute",
    top: 8,
    right: 8,
    backgroundColor: "#ff4444",
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    zIndex: 1,
  },
  discountText: {
    color: "#fff",
    fontSize: 10,
    fontWeight: "bold",
  },
  infoContainer: {
    width: "100%",
    marginBottom: 12,
  },
  title: {
    fontSize: 13,
    fontWeight: "600",
    color: "#333",
    marginBottom: 4,
    height: 36, // Ensure 2 lines height consistency
  },
  sku: {
    fontSize: 11,
    color: "#999",
  },
  outOfStock: {
    fontSize: 11,
    color: "#ff4444",
    marginTop: 2,
  },
  lowStock: {
    fontSize: 11,
    color: "#FF9800",
    marginTop: 2,
    fontWeight: "600",
  },
  inStock: {
    fontSize: 11,
    color: "#4CAF50",
    marginTop: 2,
  },
  priceRow: {
    flexDirection: "column",
    marginTop: 4,
  },
  oldPrice: {
    fontSize: 11,
    color: "#999",
    textDecorationLine: "line-through",
  },
  price: {
    fontSize: 15,
    fontWeight: "bold",
    color: "#2a2a8e",
  },
  actionsContainer: {
    width: "100%",
    alignItems: "center",
    gap: 8,
  },
  quantityControl: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F4F6FD",
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#E0E0E0",
    width: "100%",
    justifyContent: "space-between",
  },
  qtyButton: {
    padding: 6,
    backgroundColor: "#fff",
    borderRadius: 5,
    margin: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 1,
    elevation: 1,
  },
  qtyInput: {
    width: 30,
    textAlign: "center",
    fontSize: 13,
    fontWeight: "600",
    color: "#333",
  },
  addButton: {
    width: "100%",
    backgroundColor: "#2a2a8e",
    paddingVertical: 10,
    borderRadius: 8,
    alignItems: "center",
    shadowColor: "#2a2a8e",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 2,
  },
  addButtonText: {
    color: "#fff",
    fontSize: 13,
    fontWeight: "600",
  },
});
